const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const ENV = import.meta.env.VITE_ENV;
const FIREBASE_CONFIG = import.meta.env.VITE_FIREBASE_CONFIG;
const LAST_COMMIT_HASH = import.meta.env.VITE_LAST_COMMIT_HASH;

export { API_BASE_URL, ENV, FIREBASE_CONFIG, LAST_COMMIT_HASH };
